//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OperationBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectNXObject.js";
import "../no/ugmath.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AvailFilterToggle",1,0],[0,"AvailStateEnum",1,0],[1,"AvailableSelection",0,"SelectNXObjectList",0],[0,"ConstName",1,0],[0,"CurrentStateEnum",1,0],[0,"DesignCreation",1,0],[0,"DesignOffsetGeometry",1,"NXObject",0],[0,"DestinationPcsEnum",1,0],[0,"DirectionSpecifiedEnum",1,0],[0,"DirectionVector",1,"Direction",0],[0,"ExtractEdgeDistance",1,0],[0,"ExtractEndDistance",1,0],[0,"ExtractStartDistance",1,0],[0,"FeatureTypeEnum",1,0],[0,"MethodEnum",1,0],[0,"MoveDistance",1,0],[0,"NominalName",1,0],[0,"PcsName",1,0],[1,"SelectNominalFeature",0,"SelectNXObject",0],[0,"StepSize",1,0],[0,"SubFeat1Filter",1,0],[0,"SubFeat1Name",1,0],[1,"SubFeat1Select",0,"SelectNXObject",0],[0,"SubFeat1StateEnum",1,0],[0,"SubFeat2Filter",1,0],[0,"SubFeat2Name",1,0],[1,"SubFeat2Select",0,"SelectNXObject",0],[0,"SubFeat2StateEnum",1,0]],[[[],"CycleSolution",{},0,0],[[],"CreateNominal",{},0,0],[["nSubFeatures"],"GetSubFeatures",{R_:{subFeatures:""}},0,0],[["subFeatures"],"SetSubFeatures",{},1,0],[["vector"],"UpdateDirectionVector",{},1,0],[["nSubFeatures"],"GetSubFeatureStates",{R_:{subFeatureStates:""}},0,0],[["subFeatureStates"],"SetSubFeatureStates",{},1,0]],[]];
SPLM.CAM.InspectionConstructedFeatureBuilder = class extends SPLM.CAM.OperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionConstructedFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.InspectionConstructedFeatureBuilder.ConstFeatType = Object.freeze({
    "Point" : "Point", "Line" : "Line", "Plane" : "Plane", "Arc" : "Arc", "Circle" : "Circle", "Cylinder" : "Cylinder", "Cone" : "Cone", "Sphere" : "Sphere", "Curve" : "Curve", "Torus" : "Torus", "Surface" : "Surface", "SlotTab" : "SlotTab"});

SPLM.CAM.InspectionConstructedFeatureBuilder.MethodEnumType = Object.freeze({
    "BestFit" : "BestFit", "Transform" : "Transform", "Intersection" : "Intersection", "Minimum" : "Minimum", "Maximum" : "Maximum", "Projection" : "Projection", "MoveByFeature" : "MoveByFeature", "MoveByVector" : "MoveByVector", "PerpendicularTo" : "PerpendicularTo", "ParallelTo" : "ParallelTo", "Offset" : "Offset", "Middle" : "Middle", "ConeDiameter" : "ConeDiameter", "ConeDistance" : "ConeDistance", "Extract" : "Extract", "TangentTo" : "TangentTo"});

SPLM.CAM.InspectionConstructedFeatureBuilder.AvailableStateType = Object.freeze({
    "Nominal" : "Nominal", "Actual" : "Actual"});

SPLM.CAM.InspectionConstructedFeatureBuilder.CurrentStateType = Object.freeze({
    "Nominal" : "Nominal", "Actual" : "Actual"});

SPLM.CAM.InspectionConstructedFeatureBuilder.DestPcsEnumType = Object.freeze({
    "CurrentPCS" : "CurrentPCS", "NominalPCS" : "NominalPCS", "ActualPCS" : "ActualPCS"});

SPLM.CAM.InspectionConstructedFeatureBuilder.DirectionType = Object.freeze({
    "SpecifiedVector" : "SpecifiedVector", "Radial" : "Radial", "Feature" : "Feature"});

SPLM.CAM.InspectionConstructedFeatureBuilder.SubFeat1StateType = Object.freeze({
    "Nominal" : "Nominal", "Actual" : "Actual"});

SPLM.CAM.InspectionConstructedFeatureBuilder.SubFeat2StateType = Object.freeze({
    "Nominal" : "Nominal", "Actual" : "Actual"});

SPLM.CAM.InspectionConstructedFeatureBuilder.DesignCreationType = Object.freeze({
    "SelectExisting" : "SelectExisting", "CreateNew" : "CreateNew"});

SPLM.CAM.InspectionConstructedFeatureBuilder.ExtractEdgeDistanceType = Object.freeze({
    "Absolute" : "Absolute", "Percentage" : "Percentage"});

export default SPLM;